module.exports = __webpack_public_path__ + "img/bookmark-star.b9010ebb.svg";